export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

const ITERATIONS = 210_000;
const SALT_BYTES = 16;

function base64Url(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/** Derives the value sent to the server; the password itself never leaves the browser. */
export async function passwordProof(password: string, salt?: Uint8Array) {
  const passwordSalt = salt ?? crypto.getRandomValues(new Uint8Array(SALT_BYTES));
  const key = await crypto.subtle.importKey(
    'raw',
    new TextEncoder().encode(password),
    'PBKDF2',
    false,
    ['deriveBits'],
  );
  const verifier = await crypto.subtle.deriveBits(
    {
      name: 'PBKDF2',
      hash: 'SHA-256',
      salt: Uint8Array.from(passwordSalt).buffer,
      iterations: ITERATIONS,
    },
    key,
    256,
  );
  return { salt: base64Url(passwordSalt), verifier: base64Url(new Uint8Array(verifier)) };
}

export function saltBytes(salt: string): Uint8Array {
  const base64 = salt.replace(/-/g, '+').replace(/_/g, '/').padEnd(24, '=');
  return Uint8Array.from(atob(base64), (character) => character.charCodeAt(0));
}
